exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ImageUpload-637aa2b9{margin:0 0 20px 0;font-size:13px;border:1px solid #C8C8C8;border-radius:2px;padding:10px 15px;cursor:pointer;display:block;text-align:center;padding:10px}.ImageUpload-637aa2b9 .hintTop-fc7b5f10{color:#757575;margin-bottom:10px}.ImageUpload-637aa2b9 .hintBottom-663a47b4{color:#757575;margin-top:10px}.ImageUpload-637aa2b9.active-c473fc83{border:1px solid #FA6400}.ImageUpload-637aa2b9.reject-56982090{border:1px solid #FF3940}\n", ""]);

// Exports
exports.locals = {
	"ImageUpload": "ImageUpload-637aa2b9",
	"hintTop": "hintTop-fc7b5f10",
	"hintBottom": "hintBottom-663a47b4",
	"active": "active-c473fc83",
	"reject": "reject-56982090"
};